import { type FlowLogEvent } from '../../../types/flow-log';

export const getSubtitleForModuleType = (event: FlowLogEvent): string | undefined => {
  const { ContactFlowModuleType, Parameters, ContactFlowName } = event;

  if (!Parameters) {
    return undefined;
  }

  switch (ContactFlowModuleType) {
    case 'SetWisdomAssistant':
      return `${Parameters.WisdomAssistantArn}`;
    case 'MessageParticipant':
    case 'PlayPrompt':
      return `${Parameters.Text ?? Parameters.SSML}`;
    case 'InvokeExternalResource':
      if (Parameters.FunctionArn && typeof Parameters.FunctionArn === 'string') {
        const arnParts = Parameters.FunctionArn.split(':');
        if (arnParts.length >= 7) {
          return `λ ${arnParts[6]}`;
        }
      }

      return `${JSON.stringify(Parameters, null, 2)}`;
    case 'GetUserInput':
    case 'GetParticipantInput':
      return `${Parameters.BotAliasArn} - ${Parameters.Text} `;
    case 'SetAttributes':
      return `${Parameters.Key} = ${Parameters.Value}`;
    case 'CheckAttribute':
      return `${Parameters.Value} ${Parameters.ComparisonMethod} ${Parameters.SecondValue}`;
    case 'SetContactAttributes':
    case 'GetContactAttributes':
      if (Parameters.Attributes && typeof Parameters.Attributes === 'object') {
        const keys = Object.keys(Parameters.Attributes);
        return keys.length > 0 ? keys.join(', ') : ContactFlowName;
      }
      return ContactFlowName;
    case 'SetVoice':
      return Parameters.GlobalVoice
        ? `${Parameters.GlobalVoice}`
        : `${Parameters.Value} - ${Parameters.GlobalEngine} - ${Parameters.SpeakingStyle}`;
    case 'SetQueue':
      return String(Parameters.Queue);
    case 'FlowStart':
    case 'FlowEnd':
      return ContactFlowName;
    case 'SetLoggingBehavior':
      return Parameters.LoggingBehavior ? String(Parameters.LoggingBehavior) : ContactFlowName;
    case 'SetDisconnectFlowBehavior':
      return Parameters.DisconnectFlowName ? String(Parameters.DisconnectFlowName) : ContactFlowName;
    case 'LoopPrompts':
      if (Parameters.AudioPrompt) {
        return String(Parameters.AudioPrompt);
      }

      if (Parameters.Text) {
        return String(Parameters.Text);
      }
    // falls through
    case 'SetHoldMusicBehavior':
    case 'TransferContactToAgent':
    default:
      if (Object.keys(Parameters).length === 0) {
        return '';
      }

      return `${JSON.stringify(Parameters, null, 2)} `;
  }
};

export const getParametersForModuleType = (event: FlowLogEvent): Record<string, unknown> | undefined => {
  const { Parameters } = event;

  if (!Parameters || Object.keys(Parameters).length === 0) {
    return undefined;
  }

  return Parameters;
};
